export const trousers = [0.16, 0.2, 0.32];
